import React, { useState } from "react";
import ApiCustom from "../../utils/ApiCustom";
import { toast } from "react-toastify";
const NotiPreview = ({ post, onClose, registrations }) => {
  const [formData, setFormData] = useState({
    title: post?.title || "",
    content: post?.content || null,
    status: post?.status || "draft",
    seoTitle: post?.seoTitle || "",
    seoDescription: post?.seoDescription || "",
    seoKeywords: post?.seoKeywords || "",
    cateGory: post?.cateGory || "",
    images: null,
    categoryId: post?.categoryId || "",
    userEmails: post?.user?.userEmails || [],
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      status: "published",
    };
    ApiCustom.put("/notification-approve/" + post?.id, data)
      .then((res) => {
        setTimeout(() => {
          toast.success("Duyệt thông báo thành công!");
        }, 300);
        onClose();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 p-6 rounded-lg w-3/4 max-h-[90vh] overflow-y-auto">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="w-full">
            <div className="flex justify-between items-center ">
              <h1 className="text-3xl font-bold mb-4">{formData?.title}</h1>
              <button
                onClick={onClose}
                className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>

            <div className="flow-root">
              <div className="sun-editor-editable">
                <div
                  className="prose max-w-none"
                  dangerouslySetInnerHTML={{ __html: formData?.content }}
                />
              </div>
            </div>
            <div className="mt-4">
              <strong>Số lượng người đăng ký tham gia:</strong>{" "}
              {registrations?.filter((e) => e.post?.id === post?.id)?.length}
            </div>

            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 btn btn-sm rounded btn-active btn-ghost"
              >
                Hủy
              </button>
              <button
                type="submit"
                className="px-4 py-2 btn btn-sm rounded btn-active btn-primary"
              >
                Duyệt
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotiPreview;
